define.alias("shared/components/shared/social/basic-display-deprecation/modal", "preview-grid/components/shared/social/basic-display-deprecation/modal");